
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import { getUserMoney } from '../service/getdata'
export default{
components:{
XHeader,
Toast
},
data(){
return{
eyes: true, //资产是否隐藏
msg: "",
show: false,
userMoney: {}, //用户资金信息
unit: "eur",
trade_type: 1,
symbol: "€",
list: [{
text: this.$t("加密货币"),
value: 1
},{
text: this.$t("外汇"),
value: 2
}




],

}
},
computed:{
...mapState(['token'])
},
created(){
this.SETTOKEN()
this.unit = window.localStorage.getItem('unit') || 'eur'
if(this.unit == 'eur'){
this.symbol = '€'
}else{
this.symbol= '$'
}
clearInterval(this.timerInfo)
this.timerInfo = null
this.getData(true)

this.timerInfo = setInterval(() => {
this.getData()
}, 2000);
},
methods:{
...mapMutations(['SETUSERDETAIL','SETUSER','SETTOKEN',"CLEAN_ALL"]),
getData(isLoading){
var that = this
if(!!isLoading){
this.$Loading()
}
getUserMoney({token: this.token, symbol: this.unit}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.userMoney = res.data
console.log(that.userMoney)
}else if(res.status=='-1'){
that.$router.push('/pages/login')
}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
},
choice(index){
this.trade_type = index;

},
clearTimer() { //清楚定时器

clearInterval(this.timerInfo)
this.timerInfo = null
},
sendMsg(content) {
this.msg = content;
this.show = true;
},


},
watch:{

},
deactivated() {
this.clearTimer()
},
beforeDestroy() {
this.clearTimer()
},
}



// WEBPACK FOOTER //
// ./src/pages/my.vue